import React from "react"
import { TextField } from "@shopify/polaris"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

const TextFieldAtom = ({
  property,
  value,
  type,
  error,
  onChange,
  disabled,
  label,
  inputType,
  suffix,
}) => {
  const { t } = useTranslation()

  label ||= t(`activation:${type}.questions.${property}.label`, {
    defaultValue: t(`activation:common.questions.${property}`, {
      defaultValue: "",
    }),
  })

  return (
    <TextField
      label={label}
      id={property}
      name={property}
      value={value}
      error={error}
      onChange={onChange}
      type={inputType}
      inputMode="text"
      minLength="1"
      maxLength="50"
      required
      disabled={disabled}
      suffix={suffix}
    />
  )
}

TextFieldAtom.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  inputType: PropTypes.string,
  suffix: PropTypes.string,
}

TextFieldAtom.defaultProps = {
  value: null,
  node: null,
  error: null,
  disabled: false,
  inputType: "text",
  suffix: undefined,
}

export default TextFieldAtom
